import {
  LocationResponseDto,
  ProductCreateRequestDto,
} from '@tiendanube/common';
import { ProductCreateRequestApiV2Dto } from '@tiendanube/common/src/domains/catalog/interfaces';
import { LanguagesType } from 'App/i18n';
import { getCreateVariantsPayload } from './getCreateVariantsPayload';
import { getCategories, getImages, getTags } from './helpers';
import { getAttributes } from '../shared/helpers';

export function getCreateProductPayload(
  product: ProductCreateRequestDto,
  language: LanguagesType,
  locations: LocationResponseDto[],
): ProductCreateRequestApiV2Dto {
  const {
    name,
    categories,
    description,
    handle,
    published,
    attributes,
    variants,
    images,
    brand,
    free_shipping,
    requires_shipping,
    tags,
    seo_title,
    seo_description,
    video_url,
  } = product;

  const defaultName = name[language];

  return {
    name: {
      ...name,
      default: defaultName,
    },
    description: description
      ? { ...description, default: description[language] }
      : { default: '' },
    publish: published,
    attributes: attributes ? getAttributes(language, attributes) : [],
    variants: getCreateVariantsPayload(language, variants, locations),
    images: images ? getImages(images) : [],
    handle: handle ?? { default: defaultName },
    categories: getCategories(categories) ?? [],
    brand: brand,
    free_shipping: free_shipping,
    requires_shipping: requires_shipping,
    tags: getTags(tags),
    seo_title: seo_title,
    seo_description: seo_description,
    video_url: video_url,
  };
}
